import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
// import "@fullcalendar/core/main.css";
import "@fullcalendar/daygrid/main.css";
import "@fullcalendar/timegrid/main.css";



import './assets/css/variables.css';
export const bus = new Vue();

new Vue({
  el: "#app",
  router,
  store,
  render: h => h(App)
});
